import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { pingApi } from "../../api/quoteApi";

export const initializeApp = createAsyncThunk(
  "app/initializeApp",
  async (_, { rejectWithValue }) => {
    try {
      const response = await pingApi();
      if (!response) {
        throw new Error("El servidor no respondió correctamente.");
      }
      return { success: true };
    } catch (error) {
      return rejectWithValue(error.message || "No se pudo conectar al servidor.");
    }
  }
);

const initialState = {
  status: "loading",
  error: null,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    resetApp: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(initializeApp.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(initializeApp.fulfilled, (state) => {
        state.status = "ready";
      })
      .addCase(initializeApp.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetApp } = appSlice.actions;
export default appSlice.reducer;
